import React from 'react';

const DownloadIcon = () => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00625 10.5752V16.2002C2.00625 16.642 2.36442 17.0002 2.80625 17.0002H17.1812C17.3934 17.0002 17.5969 16.9159 17.7469 16.7659C17.897 16.6159 17.9813 16.4124 17.9813 16.2002V10.5752H19.5812V16.2002C19.5812 17.5257 18.5067 18.6002 17.1812 18.6002H2.80625C1.48219 18.5968 0.409685 17.5243 0.40625 16.2002V10.5752H2.00625Z"
      fill="#536BDD"
    />
    <path
      d="M10.8625 0.174805V11.7311L14.7937 7.7873L15.9812 8.9873L10.025 14.9686L4.0625 8.9873L5.25 7.7873L9.175 11.7248V0.174805H10.8625Z"
      fill="#536BDD"
    />
  </svg>
);

export default DownloadIcon;
